import _ from 'lodash'
import { NanoEvent } from './NanoEvent.js'
import { MessageFactory } from './Message'

export default class MessageQueue extends NanoEvent {
  messages = []
  lastSelfMessage = null
  lastMessage = null
  length = 0

  new (name, type, data, meta) {
    const message = MessageFactory(name, type, data, meta)
    this.push(message)
    return message
  }

  clear () {
    this.messages.splice(0, this.messages.length)
    this.lastMessage = null
    this.lastSelfMessage = null
  }

  addFromJsonObject (message) {
    const m = MessageFactory(message.name, message.type, message.data, message)
    this.push(m)
    return m
  }

  push (message) {
    if (message.name === 'self' && this.lastSelfMessage && this.lastSelfMessage.status === 'loading') {
      return null
    }
    if (message.status === 'loading') {
      message.$on('loaded', () => {
        this.$emit('message-loaded', message)
      })
    } else {
      if (this.shouldInsertMessage(message)) return
    }
    if (message.name === 'self') {
      this.lastSelfMessage = message
    }
    this.lastMessage = message
    this.messages.push(message)
    this.length = this.messages.length
    this.$emit('message-push', message)
    return this
  }

  shouldInsertMessage (message) {
    const queue = this
    const prevMessage = queue.messages.length >= 1 ? queue.messages[queue.messages.length - 1] : null
    if (prevMessage && prevMessage.isSame(message)) {
      // 折叠连续相同的同步消息
      prevMessage.repeats += 1
      this.$emit('message-loaded', prevMessage)
      return true
    }
    this.$emit('message-loaded', message)
    return false
  }

  removeDuplicateMessage (message) {
    const prevMessage = this.findPrevMessage(message)
    if (prevMessage && prevMessage.isSame(message)) {
      // 折叠连续相同的同步消息
      prevMessage.repeats += 1
      this.removeMessage(message)
      return prevMessage
    }
    return null
  }

  findPrevMessage (message) {
    const id = _.findIndex(this.messages, { id: message.id })
    if (id > 0) return this.messages[id - 1]
    return null
  }

  removeMessage (message) {
    const id = _.findIndex(this.messages, { id: message.id })
    if (id >= 0) {
      this.messages.splice(id, 1)
    }
    this.length = this.messages.length
  }
}
